import { TipoDeArquivo, TipoDelimitacao,CategoriaValor } from "../dominio/e02.enum";


export interface ConfiguracaoDelimitacao {
  tipo: TipoDelimitacao;
  quantidade_caracteres: number;
}

// texto é para o campo fixo
export interface Modificadores {
  alinhamento?: string;
  mes_da_folha?: boolean;
  mes_do_calendario?: boolean;
  proximo_mes?: boolean;
  mes_anterior?: boolean;
  primeiro_dia?: boolean;
  ultimo_dia?: boolean;
  formato_da_data?: string;
  texto?: string;
  formato_do_valor?: string;
  divisor_de_casas_decimais?: string;
  quantidade_de_casas_decimais?: number;
  quantidade_de_caracteres?: number;
  caractere_de_preenchimento?: string;
  texto_desconto?: string;
  texto_bonus?: string;
  texto_dias?: string;
  texto_horas?: string;
  delimitacao?: ConfiguracaoDelimitacao | null;
  formato_especifico_para_verbas_em_dias?: CategoriaValor | string | null;
  chave?: string;
  valor_padrao?: string;
  apenas_para_verbas_em_dias?: boolean;
  preenchimento_quando_nao_aplicavel?: string;
  sem_valor_para_verbas_em_dias?: boolean;
  valor_apenas_para_verbas_em_dias?: boolean;
  preenchimento_verbas_sem_valor?: string;
}

// "subCampo" é utilizado somente quando "campo" é "empregado" ou "empregador".
// Ambos podem ter complemento de "campo", representando qualquer propriedade dentro de sua respectiva categoria.
// Exemplo: campo = "empregado", subCampo = "codigo"
// Formato final: empregado.codigo
export interface CampoLayout {
  id?: string; // usado apenas para vuedraggable
  campo: string;
  subCampo?: string;
  modificadores: Modificadores;
}

export interface Layout {
  campos: CampoLayout[];
  formato_do_arquivo: TipoDeArquivo | null;
  separador_de_campos?: string | null; // apenas para os tipos de arquivos csv e txt
  quantidade_de_espaco?: number | null; // usado apenas para leitura
  extensao_do_arquivo?: string | null;       
  quebra_de_linha_txt?: string | null;        
  usar_aspas_para_texto_csv?: boolean | null;
  campos_do_cabecalho?: CampoLayout[]; // apenas txt: linha única montada por campos
  omitir_falta_em_apontamentos_por_verbas?: boolean;
}

// Chaves do layout que a tela edita. As demais (configuradas direto no JSON)
// são preservadas no salvamento.
export const CHAVES_DO_LAYOUT_EDITADAS_NA_TELA = [
  'campos',
  'formato_do_arquivo',
  'separador_de_campos',
  'quantidade_de_espaco',
  'extensao_do_arquivo',
  'quebra_de_linha_txt',
  'usar_aspas_para_texto_csv',
  'campos_do_cabecalho',
  'omitir_falta_em_apontamentos_por_verbas',
];

export interface DetalhesLayout {
  id: string;
  nome: string;
  empresa: string;
  codigo: number;
  nome_software_pagamento: string;
  ativo?: boolean;
  layout: Layout;
}
